/**
 * Copiar al portapapeles, y borrar lo secreto a los 30 segundos.
 *
 * ⚠ **El borrado es a ciegas: escribe vacío sin mirar qué hay.** Leer el portapapeles
 * pide un permiso al navegador, y para comprobar si sigue ahí la clave habría que
 * leerlo. El precio es que algo copiado después, en esos 30 s, también se borra — y la
 * pantalla lo avisa al copiar. Es lo que hacen los gestores de contraseñas. El sistema
 * de referencia no lo borraba nunca: la clave del banco quedaba pegable toda la tarde.
 */

export const BORRADO_MS = 30_000

let pendiente: number | undefined

export async function copiar(texto: string, secreto = false): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(texto)
  } catch {
    return false
  }
  if (secreto) {
    window.clearTimeout(pendiente)
    pendiente = window.setTimeout(() => {
      navigator.clipboard.writeText("").catch(() => undefined)
    }, BORRADO_MS)
  }
  return true
}
